<template>
  <span>
    <LeafScoreMeterAtom
      :max="5"
      :score="scoreAVG"
    />
  </span>
</template>

<script lang="ts">
import { SpaReview } from '~/core/ts/entity/SpaReview'
import LeafScoreMeterAtom from '../../spa/atom/LeafScoreMeter.atom.vue'

export default defineNuxtComponent({
  components: {
    LeafScoreMeterAtom,
  },
  props: {
    review: { type: Object as PropType<SpaReview>, required: true },
  },
  setup(props) {
    const scoreAVG = computed(() => {
      let sum = 0
      let count = 0

      Object.entries(props.review.scores).forEach(([_, value]) => {
        sum += value
        count++
      })

      return sum / count
    })

    return {
      scoreAVG
    }
  }
})
</script>
